import { PropsWithChildren } from "react";
import { TabsContext, TabsContextProps } from "./TabsContext";

export function TabsProvider({
  children,
  disabled = false,
  value
}: PropsWithChildren<TabsContextProps>) {
  return (
    <TabsContext.Provider value={{ disabled, value }}>
      {children}
    </TabsContext.Provider>
  );
}
